// Helper functions to validate the tree.

const isYearInFuture = (year) => {
  const nowYear = new Date().getFullYear()
  return nowYear < year
}

const isYearLessThanMin = (minYear, year) => {
  return year < minYear
}

const errorNameTooLong = {
  key: 'atf.ancestor-editor.validation.name-too-long',
  defaultValue: 'Please enter a name less than 50 characters.',
}

const errorNoDigits = {
  key: 'atf.ancestor-editor.validation.no-numbers',
  defaultValue: 'Please enter a name with no numbers.',
}

const errorMissingFirstName = {
  key: 'atf.ancestor-editor.validation.first-name',
  defaultValue: 'Please supply a first name.',
}

const errorMissingLastName = {
  key: 'atf.ancestor-editor.validation.last-name',
  defaultValue: 'Please supply a last name.',
}

const errorMissingBirthYear = {
  key: 'atf.ancestor-editor.validation.missing-date-of-birth',
  defaultValue: 'Please supply a date of birth.',
}

const errorBirthYearTooEarly = {
  key: 'atf.ancestor-editor.validation.birth-date-in-past',
  defaultValue: 'Please enter a birth date after 1800.',
}

const errorBirthYearInFuture = {
  key: 'atf.ancestor-editor.validation.future-date-of-birth',
  defaultValue: 'The supplied date of birth must not be in the future.',
}

// const errorMissingDeathYear = {
//   key: 'atf.AncestorEditor.validation.missingDateOfDeath',
//   defaultValue: 'Please enter a death date.',
// }

const errorDeathYearInFuture = {
  key: 'atf.ancestor-editor.validation.death-in-future',
  defaultValue: 'The supplied date of death must not be in the future.',
}

const errorDeathYearBeforeBirthYear = {
  key: 'atf.ancestor-editor.validation.death-after-birth',
  defaultValue: 'The supplied date of death must be greater than or equal to the date of birth.',
}

const errorMissingPlace = {
  key: 'atf.ancestor-editor.validation.standardized-place-birth',
  defaultValue: 'The supplied place of birth must be selected from the drop-down list.',
}

export default function isValidForm(values, includeLocation, isGuestUser) {
  let currentExperience = ''
  if (window.parent.document.URL.includes('about') || isGuestUser) {
    currentExperience = 'AAM'
  } else {
    currentExperience = 'WAIF'
  }
  const errors = { person: {} }
  const pattern = /([0-9])\d/g

  const isMissingFirstName = !values.person.name || !values.person.name.trim()
  if (isMissingFirstName) {
    errors.person.name = errorMissingFirstName
  }
  if (!isMissingFirstName && values.person.name.length > 50) {
    errors.person.name = errorNameTooLong
  }
  if (!isMissingFirstName && pattern.test(values.person.name)) {
    errors.person.name = errorNoDigits
  }

  const isMissingLastName = !values.person.surname || !values.person.surname.trim()
  if (isMissingLastName) {
    errors.person.surname = errorMissingLastName
  }
  if (!isMissingLastName && values.person.surname.length > 50) {
    errors.person.name = errorNameTooLong
  }
  if (!isMissingLastName && pattern.test(values.person.surname)) {
    errors.person.name = errorNoDigits
  }

  if (!values.person.dob && currentExperience === 'AAM') {
    errors.person.dob = errorMissingBirthYear
  }

  if (values.person.dob && isYearLessThanMin(1800, values.person.dob)) {
    errors.person.dob = errorBirthYearTooEarly
  } else if (values.person.dob && isYearInFuture(values.person.dob)) {
    errors.person.dob = errorBirthYearInFuture
  }

  if (
    (includeLocation && !values.person.pobId && currentExperience === 'WAIF') ||
    (includeLocation && values.person.pobId === 'undefined' && currentExperience === 'WAIF')
  ) {
    errors.person.pob = errorMissingPlace
  }

  if (values.person.living) {
    return errors
  }
  // if (!values.person.dod) {
  //   errors.person.dod = errorMissingDeathYear
  // }
  if (values.person.dod && isYearLessThanMin(values.person.dob, values.person.dod)) {
    errors.person.dod = errorDeathYearBeforeBirthYear
  } else if (values.person.dod && isYearInFuture(values.person.dod)) {
    errors.person.dod = errorDeathYearInFuture
  }

  // if (
  //   (includeLocation && !values.person.living && !values.person.podId) ||
  //   (includeLocation && !values.person.living && values.person.podId === 'undefined')
  // ) {
  //   errors.person.pod = errorMissingPlace
  // }

  return errors
}
